import { api } from '@api/api2';

const getData = () => api.v1('get', 'timezones/list');

export const apiRequests = { getData };
